import { type LanguageType } from '@models/entities/languages'

export const createLanguageTranslationsRequestUrl = (languageKey: LanguageType) =>
  `https://${import.meta.env.VITE_APP_DOMAIN}/files/langs/${languageKey}.csv`
